var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4369 14.7005C17.471 14.8387 17.472 14.983 17.44 15.1217C17.408 15.2605 17.3438 15.3897 17.2525 15.499C16.578 16.3082 15.7338 16.9592 14.7797 17.4059C13.8257 17.8527 12.7851 18.0842 11.7316 18.0842C10.6782 18.0842 9.63758 17.8527 8.68353 17.4059C7.72948 16.9592 6.88529 16.3082 6.21073 15.499C6.11951 15.3897 6.05529 15.2605 6.02326 15.1217C5.99123 14.983 5.99229 14.8387 6.02636 14.7005C6.33945 13.43 7.06742 12.3004 8.09499 11.4904C8.24827 11.3702 8.43673 11.3037 8.63147 11.3009C8.82621 11.2981 9.0165 11.3592 9.17316 11.475C9.85599 11.9828 10.7512 12.2904 11.7302 12.2904C12.7092 12.2904 13.604 11.9828 14.2872 11.475C14.4439 11.3592 14.6342 11.2981 14.8289 11.3009C15.0237 11.3037 15.2121 11.3702 15.3654 11.4904C16.394 12.2999 17.1231 13.4296 17.4369 14.7005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7321 11.1048C13.556 11.1048 15.0345 9.62628 15.0345 7.80241C15.0345 5.97854 13.556 4.5 11.7321 4.5C9.90823 4.5 8.42969 5.97854 8.42969 7.80241C8.42969 9.62628 9.90823 11.1048 11.7321 11.1048Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayprofile);
export default __webpack_public_path__ + "static/media/grayprofile.3e5ac7177e5b35e5d1121d783f396624.svg";
export { ForwardRef as ReactComponent };